import { ACTIVITY_FEED_HEADER_HEIGHT } from 'utils/constants';

export const styles = {
  container: {
    flex: 1,
    minHeight: 0,
    width: '457px',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    zIndex: '5',
    backgroundColor: '#FFFFFF',
    borderLeft: '1px solid #F3F4F9',
  },

  header: {
    width: '457px',
    height: `${ACTIVITY_FEED_HEADER_HEIGHT}px`,
    padding: '0 20px',
    backgroundColor: '#FAFBFC',
    display: 'flex',
    flexDirection: 'row',
    gap: '20px',
    justifyContent: 'flex-end',
    alignItems: 'center',
    borderBottom: '1px solid #F3F4F9',
  },

  mainContainer: {
    flexGrow: 1,
    minHeight: 0,
    overflowY: 'auto',
    padding: '20px 0 16px 16px',
    width: '100%',
    contain: 'strict',
    '&::-webkit-scrollbar': {
      border: 'none',
      width: '11px',
      height: '11px',
      padding: '5px 0',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: '#fff',
      border: 'none',
      height: '10px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#D4D6E0',
      width: '2px',
      borderRadius: '6px',
      cursor: 'pointer',
    },
  },

  emptyStateContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    alignItems: 'center',
    paddingTop: '150px',
  },

  emptyStateTitle: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '146%',
    color: '#23252F',
  },

  emptyStateSubtitle: {
    fontFamily: 'Inter',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '146%',
    color: '#424550',
    textAlign: 'center',
  },

  loaderContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    padding: '20px',
  },

  createPostContainer: {
    width: '100%',
  },

  searchAndFilterContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
  },
};
